import {
  IoIosHome,
  IoIosPerson,
  IoIosPeople,
  IoIosArrowForward,
  IoIosArrowBack,
  IoIosArrowDropright,
  IoIosArrowDropleft,
  IoIosArrowDropup,
  IoIosArrowDropdown,
  IoIosAdd,
  IoIosRemove,
  IoIosAddCircle,
  IoIosRemoveCircle,
  IoIosCloseCircle,
  IoIosArrowUp,
  IoIosArrowDown,
  IoIosExit,
  IoIosClose,
  IoIosPhonePortrait,
  IoIosCheckmarkCircle,
  IoIosCheckmark,
  IoIosBusiness,
  IoIosLock,
  IoIosCalendar,
  IoIosArrowRoundDown,
  IoIosShirt,
  IoIosHappy,
  IoIosCog,
  IoIosEye,
  IoMdCreate,
  IoIosTrash,
  IoIosMail,
  IoIosCamera,
  IoIosSync,
  IoIosMenu,
  IoIosList,
  IoIosRedo,
  IoIosCart,
  IoIosHeart,
  IoIosSearch,
  IoIosCash,
  IoIosCube,
  IoIosStar,
  IoIosStarHalf,
  IoIosOptions,
  IoIosDownload,
  IoIosUndo,
  IoMdShare,
  IoIosWarning,
  IoIosEyeOff,
  IoIosNotifications,
  IoIosNotificationsOff,
  IoIosPaper,
} from "react-icons/io";

import { FaUserCircle, FaFacebook, FaGoogle } from "react-icons/fa";
import { GiOrganigram } from "react-icons/gi";
import { VscGripper } from "react-icons/vsc";

/** @type {Record<string, import("react-icons").IconType>} */
const componentIcons = {
  home: IoIosHome,
  user: IoIosPerson,
  users: IoIosPeople,
  "chevron-right": IoIosArrowForward,
  "chevron-left": IoIosArrowBack,
  "chevron-up": IoIosArrowUp,
  "chevron-down": IoIosArrowDown,
  "chevron-right-circle": IoIosArrowDropright,
  "chevron-left-circle": IoIosArrowDropleft,
  "chevron-up-circle": IoIosArrowDropup,
  "chevron-down-circle": IoIosArrowDropdown,
  plus: IoIosAdd,
  minus: IoIosRemove,
  "plus-circle": IoIosAddCircle,
  "circle-minus": IoIosRemoveCircle,
  "cross-circle": IoIosCloseCircle,
  exit: IoIosExit,
  cross: IoIosClose,
  "phone-handset": IoIosPhonePortrait,
  "checkmark-circle": IoIosCheckmarkCircle,
  checkmark: IoIosCheckmark,
  store: IoIosBusiness,
  lock: IoIosLock,
  "calendar-full": IoIosCalendar,
  "sort-amount-asc": IoIosArrowRoundDown,
  shirt: IoIosShirt,
  smile: IoIosHappy,
  cog: IoIosCog,
  eye: IoIosEye,
  "eye-off": IoIosEyeOff,
  pencil: IoMdCreate,
  trash: IoIosTrash,
  envelope: IoIosMail,
  camera: IoIosCamera,
  magnifier: IoIosSearch,
  sync: IoIosSync,
  menu: IoIosMenu,
  list: IoIosList,
  redo: IoIosRedo,
  cart: IoIosCart,
  heart: IoIosHeart,
  cash: IoIosCash,
  cube: IoIosCube,
  star: IoIosStar,
  "star-half": IoIosStarHalf,
  options: IoIosOptions,
  download: IoIosDownload,
  undo: IoIosUndo,
  share: IoMdShare,
  warn: IoIosWarning,
  "user-circle": FaUserCircle,
  organigram: GiOrganigram,
  gripper: VscGripper,
  facebook: FaFacebook,
  google: FaGoogle,
  notification: IoIosNotifications,
  "notification-off": IoIosNotificationsOff,
  paper: IoIosPaper,
};

/** @type {string[]} */
const svgIcons = ["credit-card"];

export default {
  componentIcons,
  svgIcons,
};
